import { useMutation } from "@tanstack/react-query";
import { updateSplashTimeout } from "../../api/ciscoMerakiApi";

export const useUpdateCiscoMerakiSplashTimeout = () => {
  return useMutation({
    mutationFn: (data) => updateSplashTimeout(data),
    onSuccess: (response) => {
      console.log("Splash timeout updated successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error updating splash timeout:", error);
    },
  });
};